export const ROSTER_COLUMN_DESCRIPTIONS = {
  employees: 'Employees',
  employeeId: 'Employee ID',
  locations: 'Locations',
  positions: 'Positions',
  groups: 'Groups',
  tags: 'Tags',
  shiftTime: 'Shift time',
  status: 'Status',
};

export const ROSTER_SORT_MAP = {
  employees: 'user.fullname',
  employeeId: 'user.employeeId',
  locations: 'location.name',
  positions: 'position.name',
  groups: 'user.groups[0].name',
  tags: 'tags[0].name',
  shiftTime: 'dtstart',
  default: 'user.fullname',
  status: 'rosterStatus.title',
};

export const ROSTER_STATUSES = {
  late: {
    title: 'Running late',
    classes: 'color-brand-danger',
  },
  clockedIn: {
    title: 'Clocked in $arrivalTime',
    classes: 'color-brand-success',
  },
  clockedOut: {
    title: 'Clocked out $departureTime',
    classes: '',
  },
  onBreak: {
    title: 'On break',
    classes: 'color-brand-warning',
  },
  sickCallout: {
    title: 'Sick callout',
    classes: '',
  },
  noShow: {
    title: 'No show',
    classes: '',
  },
  noShift: {
    title: '-',
    classes: '',
  },
};
